import { useMemo } from "react";
import { getUser } from "../utils/storage";

/**
 * usePermission Hook
 *
 * Returns permission flags for a specific module based on the
 * logged-in user's stored permissions.
 *
 * Usage:
 *   const { canView, canEdit, canDelete, canApprove } = usePermission('deliveryPartners');
 *
 *   {canEdit && <Button onClick={handleEdit}>Edit</Button>}
 *   {canDelete && <Button onClick={handleDelete}>Delete</Button>}
 *
 * Module keys: dashboard, deliveryPartners, transactions, cashCOD,
 *              payrollExpenses, payouts, usersLeaves, accounts,
 *              communications, settings
 */
export default function usePermission(module) {
  const user = getUser();

  return useMemo(() => {
    const perms = user?.permissions?.[module];

    if (!perms) {
      return {
        canView: false,
        canEdit: false,
        canDelete: false,
        canApprove: false,
      };
    }

    return {
      canView: !!perms.view,
      canEdit: !!perms.edit,
      canDelete: !!perms.delete,
      canApprove: !!perms.approve,
    };
  }, [user, module]);
}
